/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { useHistory } from 'react-router-dom';

/**
 * Hook para abrir rotas em nova guia via clique.
 */
export const useOpenInNewTab = () => {
  const history = useHistory();
  return (to: string) => {
    const href = history.createHref({ pathname: to });
    window.open(href, '_blank', 'noopener,noreferrer');
  };
};
